import {
  fetchCollections,
  fetchCollectionBySlug,
  fetchDefaultCollection,
} from '../actions/collectionActions';

export interface Collection {
  id: number;
  slug: string;
  name: string;
  default: boolean;
  public: boolean;
  created_at: string;
}

const initialState = {
  collections: [] as Collection[],
  activeCollection: {} as Collection,
};

export const collection = (state = initialState, action) => {
  switch (action.type) {
    case fetchCollections.success:
      return {
        ...state,
        collections: action.payload,
      };
    case fetchCollectionBySlug.success:
      return {
        ...state,
        activeCollection: action.payload,
      };
    case fetchDefaultCollection.success:
      return {
        ...state,
        activeCollection: action.payload,
      };
    default:
      return state;
  }
};
